import React from 'react';

import { createComponent, Layout, Header, Label, enums, PropTypes } from 'console-kit';
import authStatics from '../../../common/static';
import AuthImageLogo from '../../../components/AuthImageLogo';

const SsoFailPanel = createComponent({
  displayName: 'SsoFailPanel',
  propTypes:   {
    loginLink: PropTypes.string,
    userId:    PropTypes.string,
    message:   PropTypes.string,
  },
  defaultProps: {
    loginLink: undefined,
    userId:    undefined,
    message:   undefined,
  },
  render(props) {
    return (
      <div className={authStatics.SCREEN_CLASSES}>
        <Layout isFluidHeight>
          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.CENTER}>
              <AuthImageLogo />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Header
                text="Sorry"
                isDividing={false}
                font={{
                  emphasis: enums.font.emphasis.NORMAL,
                }}
                size={enums.sizes.X6}
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Label
                text={
                  <span>
                    We could not login user: <b>{props.userId}</b>. Please check with your system administrator. Error
                    Message was: {props.message}
                  </span>
                }
                hasPadding={false}
                display={enums.display.PLAIN}
                size={enums.sizes.X4}
                isFluid
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Label
                text={
                  <span>
                    Go to you login url to log in: <a href={props.loginLink}> Login </a>
                  </span>
                }
                hasPadding={false}
                display={enums.display.PLAIN}
                size={enums.sizes.X4}
                isFluid
              />
            </Layout.Column>
          </Layout.Row>
        </Layout>
      </div>
    );
  },
});

export default SsoFailPanel;
